import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {
	DataTableModule,
	ButtonModule,
	MultiSelectModule,
	ContextMenuModule
} from 'primeng/primeng';

import { ContactTableComponent } from './contact-table.component';

@NgModule({
  imports: [
    CommonModule,
	TranslateModule,
	RouterModule,
	NgbModule.forRoot(),
	DataTableModule,
	ButtonModule,
	MultiSelectModule,
	ContextMenuModule
  ],
  declarations: [ContactTableComponent],
  exports: [ContactTableComponent]
})
export class ContactTableModule { }



// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/modules/contact-table/contact-table.module.ts